/* Options:
Date: 2026-06-29 09:30:02
Version: 6.80
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5005

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: immerable:immer
*/

import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export interface IGet
{
}

// @DataContract
export class ParticipantDocument
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public participantLabel?: string;

    // @DataMember(Order=3)
    public documentId?: number;

    // @DataMember(Order=4)
    public documentState?: number;

    // @DataMember(Order=5)
    public documentVerified?: string;

    // @DataMember(Order=6)
    public redacted?: string;

    // @DataMember(Order=7)
    public processedDate?: string;

    // @DataMember(Order=8)
    public dateEntered?: string;

    // @DataMember(Order=9)
    public dateModified?: string;

    // @DataMember(Order=10)
    public modifiedBy?: string;

    // @DataMember(Order=11)
    public enteredBy?: string;

    public constructor(init?: Partial<ParticipantDocument>) { (Object as any).assign(this, init); }
}

export enum Permission
{
    OpmsAccess = 1,
    OpmsInstitutionView = 2,
    OpmsAdminister = 3,
    OpmsPatientView = 4,
    SystemAdminister = 5,
    OpmsPatientUpdate = 6,
    OpmsMasterGroupAdminister = 7,
    OpmsCoordinatingGroupAdminister = 8,
    PathologyTestAdminister = 9,
    BlockShipmentDetailsView = 10,
    OpmsPatientRegister = 11,
    OpmsPatientRandomise = 12,
    SaeView = 13,
    SaeReview = 14,
    ScreeningLogView = 15,
    ScreeningLogUpdate = 16,
    TeleformView = 17,
    TeleformManage = 18,
    EcrfView = 19,
    SaeAdminister = 20,
    MedicalReviewAccess = 21,
    MedicalReviewPerform = 22,
    MedicalReviewAdminister = 23,
    HistopathologyAccess = 24,
    DrugManagementView = 25,
    DrugManagementAdminister = 26,
    DrugManagementDispenseDrug = 27,
    OpmsProView = 28,
    OpmsProUpdate = 29,
    OpmsProAdminister = 30,
    OpmsPatientImpersonate = 31,
    OpmsPatientAccountManagement = 32,
    OpmsCrfView = 33,
    OpmsCrfUpdate = 34,
    OpmsEventView = 35,
    OpmsEventUpdate = 36,
    OpmsConsentAdminister = 37,
    OpmsCoordinatingGroupContactView = 38,
    OpmsSaeInvestigatorNotify = 39,
    EConsentView = 40,
    EConsentAdminister = 41,
    EConsentManage = 42,
    PISignOffView = 43,
    PISignOffPerform = 44,
    PISignOffAdminister = 45,
    OpmsDataManage = 46,
    RedactVerificationAccess = 47,
    ReconsentAdminister = 48,
}

export interface IReportRequest
{
    token?: string;
}

export class ClientAppSettingsService
{
    [immerable]? = true;


    public constructor(init?: Partial<ClientAppSettingsService>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public fieldName?: string;

    // @DataMember(Order=3)
    public message?: string;

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public message?: string;

    // @DataMember(Order=3)
    public stackTrace?: string;

    // @DataMember(Order=4)
    public errors?: ResponseError[];

    // @DataMember(Order=5)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OverallRedactionReasonsRow
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialName?: string;

    // @DataMember(Order=2)
    public nameInitials?: number;

    // @DataMember(Order=3)
    public dob?: number;

    // @DataMember(Order=4)
    public address?: number;

    // @DataMember(Order=5)
    public phoneNumber?: number;

    // @DataMember(Order=6)
    public mrUr?: number;

    // @DataMember(Order=7)
    public emailAddress?: number;

    // @DataMember(Order=8)
    public nextOfKin?: number;

    // @DataMember(Order=9)
    public labId?: number;

    // @DataMember(Order=10)
    public radiologyPatientId?: number;

    // @DataMember(Order=10)
    public missingPatientId?: number;

    // @DataMember(Order=11)
    public wrongPatientId?: number;

    // @DataMember(Order=12)
    public missingPage?: number;

    // @DataMember(Order=13)
    public poorRedaction?: number;

    // @DataMember(Order=14)
    public nonTrialPerson?: number;

    // @DataMember(Order=15)
    public other?: number;

    public constructor(init?: Partial<OverallRedactionReasonsRow>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Trial
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name?: string;

    // @DataMember(Order=3)
    public oid?: string;

    // @DataMember(Order=4)
    public uniqueIdentifier?: string;

    // @DataMember(Order=5)
    public secondaryIdentifier?: string;

    public constructor(init?: Partial<Trial>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialMetadata
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name?: string;

    // @DataMember(Order=3)
    public emailAddress?: string;

    // @DataMember(Order=4)
    public oid?: string;

    // @DataMember(Order=5)
    public uniqueIdentifier?: string;

    // @DataMember(Order=6)
    public secondaryIdentifier?: string;

    // @DataMember(Order=7)
    public totalDocuments?: number;

    // @DataMember(Order=8)
    public verifiedDocuments?: number;

    public constructor(init?: Partial<TrialMetadata>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroup
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public code?: string;

    // @DataMember(Order=4)
    public name?: string;

    // @DataMember(Order=5)
    public defaultName?: string;

    public constructor(init?: Partial<MasterGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CoordinatingGroup
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public code?: string;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public defaultName?: string;

    public constructor(init?: Partial<CoordinatingGroup>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Institution
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public masterGroupId?: number;

    // @DataMember(Order=4)
    public coordinatingGroupId?: number;

    // @DataMember(Order=5)
    public name?: string;

    // @DataMember(Order=6)
    public code?: string;

    // @DataMember(Order=7)
    public oid?: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export class Personnel
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public firstName?: string;

    // @DataMember(Order=3)
    public lastName?: string;

    public constructor(init?: Partial<Personnel>) { (Object as any).assign(this, init); }
}

export enum StudySubjectStatus
{
    Available = 1,
    Unavailable = 2,
    Private = 3,
    Pending = 4,
    Deleted = 5,
    Locked = 6,
    AutoDeleted = 7,
    Signed = 8,
    Frozen = 9,
    SourceDataVerification = 10,
}

// @DataContract
export class Participant
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public label?: string;

    // @DataMember(Order=3)
    public secondaryLabel?: string;

    // @DataMember(Order=4)
    public oid?: string;

    // @DataMember(Order=5)
    public trialId?: number;

    // @DataMember(Order=6)
    public trialUniqueIdentifier?: string;

    // @DataMember(Order=7)
    public trialSecondaryIdentifier?: string;

    // @DataMember(Order=8)
    public trialOid?: string;

    // @DataMember(Order=9)
    public institutionId?: number;

    // @DataMember(Order=10)
    public institutionUniqueIdentifier?: string;

    // @DataMember(Order=11)
    public institutionSecondaryIdentifier?: string;

    // @DataMember(Order=12)
    public institutionOid?: string;

    // @DataMember(Order=13)
    public dateEnrolled?: string;

    // @DataMember(Order=14)
    public dateUpdated?: string;

    // @DataMember(Order=15)
    public status?: StudySubjectStatus;

    public constructor(init?: Partial<Participant>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ParticipantMetadata extends Participant
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public totalDocuments?: number;

    // @DataMember(Order=2)
    public verifiedDocuments?: number;

    public constructor(init?: Partial<ParticipantMetadata>) { super(init); (Object as any).assign(this, init); }
}

export enum ItemDataType
{
    NullableBoolean = 1,
    Boolean = 2,
    EncapsulatedData = 3,
    PhoneNumber = 4,
    String = 5,
    Integer = 6,
    Float = 7,
    Set = 8,
    Date = 9,
    PartialDate = 10,
    File = 11,
}

export class DocumentFile
{
    [immerable]? = true;

    public itemDataId?: number;
    public itemGroupMetadataId?: number;
    public itemGroupId?: number;
    public uniqueGroupId?: string;
    public name?: string;
    public itemDataType?: ItemDataType;
    public label?: string;
    public ordinal?: number;
    public value?: string;
    public responseTypeId?: number;
    public optionsText?: string;
    public optionsValues?: string;
    public itemFormOrdinal?: number;

    public constructor(init?: Partial<DocumentFile>) { (Object as any).assign(this, init); }
}

export class DocumentGroup
{
    [immerable]? = true;

    public uniqueGroupId?: string;
    public repeat?: number;
    public repeating?: boolean;
    public eventCrfId?: number;
    public itemGroupId?: number;
    public itemGroupMetadataId?: number;
    public itemGroupName?: string;
    public itemGroupMetadataName?: string;
    public files?: DocumentFile[];

    public constructor(init?: Partial<DocumentGroup>) { (Object as any).assign(this, init); }
}

export class DocumentForm
{
    [immerable]? = true;

    public eventCrfId?: number;
    public crfVersionId?: number;
    public studyEventId?: number;
    public formName?: string;
    public formOid?: string;
    public versionName?: string;
    public ordinal?: number;
    public groups?: DocumentGroup[];

    public constructor(init?: Partial<DocumentForm>) { (Object as any).assign(this, init); }
}

export class DocumentEvent
{
    [immerable]? = true;

    public id?: number;
    public name?: string;
    public repeat?: number;
    public repeating?: boolean;
    public order?: number;
    public oid?: string;
    public updaterFirstName?: string;
    public updaterLastName?: string;
    public updaterUsername?: string;
    public status?: StudySubjectStatus;
    public forms?: DocumentForm[];

    public constructor(init?: Partial<DocumentEvent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TrialRedactionStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialName?: string;

    // @DataMember(Order=2)
    public documentsVerified?: number;

    // @DataMember(Order=3)
    public documentsProcessedAndVerified?: number;

    // @DataMember(Order=4)
    public documentsPending?: number;

    public constructor(init?: Partial<TrialRedactionStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SiteRedactionStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public siteName?: string;

    // @DataMember(Order=2)
    public documentsVerified?: number;

    // @DataMember(Order=3)
    public documentsProcessedAndVerified?: number;

    // @DataMember(Order=4)
    public documentsPending?: number;

    public constructor(init?: Partial<SiteRedactionStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LsgSiteRedactionStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public lsgName?: string;

    // @DataMember(Order=2)
    public siteName?: string;

    // @DataMember(Order=3)
    public documentsVerified?: number;

    // @DataMember(Order=4)
    public documentsProcessedAndVerified?: number;

    // @DataMember(Order=5)
    public documentsPending?: number;

    public constructor(init?: Partial<LsgSiteRedactionStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CoordinatingGroupSelectOption
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public coordinatingGroupId?: number;

    // @DataMember(Order=2)
    public coordinatingGroupName?: string;

    public constructor(init?: Partial<CoordinatingGroupSelectOption>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionSelectOption
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public institutionId?: number;

    // @DataMember(Order=2)
    public institutionName?: string;

    public constructor(init?: Partial<InstitutionSelectOption>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LsgAndSiteRedactionReasonsRow
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public coordinatingGroupName?: string;

    // @DataMember(Order=2)
    public trialName?: string;

    // @DataMember(Order=3)
    public institutionName?: string;

    // @DataMember(Order=4)
    public nameInitials?: number;

    // @DataMember(Order=5)
    public dob?: number;

    // @DataMember(Order=6)
    public address?: number;

    // @DataMember(Order=7)
    public phoneNumber?: number;

    // @DataMember(Order=8)
    public mrUr?: number;

    // @DataMember(Order=9)
    public emailAddress?: number;

    // @DataMember(Order=10)
    public nextOfKin?: number;

    // @DataMember(Order=11)
    public labId?: number;

    // @DataMember(Order=12)
    public radiologyPatientId?: number;

    // @DataMember(Order=13)
    public missingPatientId?: number;

    // @DataMember(Order=14)
    public wrongPatientId?: number;

    // @DataMember(Order=15)
    public missingPage?: number;

    // @DataMember(Order=16)
    public poorRedaction?: number;

    // @DataMember(Order=17)
    public other?: number;

    public constructor(init?: Partial<LsgAndSiteRedactionReasonsRow>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    [immerable]? = true;

    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public profileSessionSampleRate?: number;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable]? = true;

    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public key?: string;

    // @DataMember(Order=2)
    public keyType?: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CreateDocumentStateResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public document?: ParticipantDocument;

    public constructor(init?: Partial<CreateDocumentStateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetDocumentStatesByLabelResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public documentStates?: ParticipantDocument[];

    public constructor(init?: Partial<GetDocumentStatesByLabelResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UpdateDocumentStateResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UpdateDocumentStateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class NotifySiteResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<NotifySiteResponse>) { (Object as any).assign(this, init); }
}

export class SendNotifySitesOfProcessedAndVerifiedDocumentsEmailResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendNotifySitesOfProcessedAndVerifiedDocumentsEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostHasUserPermissionsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public hasPermission?: { [index: number]: boolean; };

    public constructor(init?: Partial<PostHasUserPermissionsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public trials?: Trial[];

    public constructor(init?: Partial<GetTrialsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialsMetadataResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public trials?: TrialMetadata[];

    public constructor(init?: Partial<GetTrialsMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialByIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public trial?: TrialMetadata;

    public constructor(init?: Partial<GetTrialByIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialByOidResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public trial?: TrialMetadata;

    public constructor(init?: Partial<GetTrialByOidResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetMasterGroupsByTrialIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public masterGroups?: MasterGroup[];

    public constructor(init?: Partial<GetMasterGroupsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCoordinatingGroupsByTrialIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public coordinatingGroups?: CoordinatingGroup[];

    public constructor(init?: Partial<GetCoordinatingGroupsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetInstitutionsByTrialIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public institutions?: Institution[];

    public constructor(init?: Partial<GetInstitutionsByTrialIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialCoordinatorsByTrialIdInstitutionCodeResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public personnel?: Personnel[];

    public constructor(init?: Partial<GetTrialCoordinatorsByTrialIdInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetParticipantsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public participants?: ParticipantMetadata[];

    public constructor(init?: Partial<GetParticipantsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetParticipantByLabelResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public participant?: ParticipantMetadata;

    // @DataMember(Order=3)
    public events?: DocumentEvent[];

    public constructor(init?: Partial<GetParticipantByLabelResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetDocumentVerificationEventsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public verificationEvents?: DocumentEvent[];

    public constructor(init?: Partial<GetDocumentVerificationEventsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetWeeklyProcessVerificationEventStatsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public totalDocumentsReviewed?: number;

    // @DataMember(Order=3)
    public totalDocumentsWithErrors?: number;

    // @DataMember(Order=4)
    public errorsCorrected?: string[];

    // @DataMember(Order=5)
    public additionalComments?: string[];

    // @DataMember(Order=6)
    public weekStart?: string;

    // @DataMember(Order=7)
    public weekEnd?: string;

    public constructor(init?: Partial<GetWeeklyProcessVerificationEventStatsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetProcessVerificationDataByDocumentIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public redactedFields?: string[];

    // @DataMember(Order=3)
    public comments?: string;

    public constructor(init?: Partial<GetProcessVerificationDataByDocumentIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UpdateOpenClinicaDocumentResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UpdateOpenClinicaDocumentResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetOverallTrialRedactionStatusResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: TrialRedactionStatus[];

    public constructor(init?: Partial<GetOverallTrialRedactionStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetTrialAndSiteRedactionStatusResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: SiteRedactionStatus[];

    public constructor(init?: Partial<GetTrialAndSiteRedactionStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetLsgAndSiteStatusResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: LsgSiteRedactionStatus[];

    public constructor(init?: Partial<GetLsgAndSiteStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetLsgSelectOptionsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public options?: CoordinatingGroupSelectOption[];

    public constructor(init?: Partial<GetLsgSelectOptionsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetSiteSelectOptionsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public options?: InstitutionSelectOption[];

    public constructor(init?: Partial<GetSiteSelectOptionsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetOverallRedactionReasonsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: OverallRedactionReasonsRow[];

    public constructor(init?: Partial<GetOverallRedactionReasonsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetLsgAndSiteRedactionReasonsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: LsgAndSiteRedactionReasonsRow[];

    public constructor(init?: Partial<GetLsgAndSiteRedactionReasonsResponse>) { (Object as any).assign(this, init); }
}

export class GetTpPendingDocumentsResponse
{
    [immerable]? = true;

    public data?: { [index: string]: string; };
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetTpPendingDocumentsResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    [immerable]? = true;

    public settings?: ClientAppSettings;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userId?: string;

    // @DataMember(Order=2)
    public sessionId?: string;

    // @DataMember(Order=3)
    public userName?: string;

    // @DataMember(Order=4)
    public displayName?: string;

    // @DataMember(Order=5)
    public referrerUrl?: string;

    // @DataMember(Order=6)
    public bearerToken?: string;

    // @DataMember(Order=7)
    public refreshToken?: string;

    // @DataMember(Order=8)
    public profileUrl?: string;

    // @DataMember(Order=9)
    public roles?: string[];

    // @DataMember(Order=10)
    public permissions?: string[];

    // @DataMember(Order=11)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=12)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @Route("/files/state/create")
// @DataContract
export class CreateDocumentState implements IReturn<CreateDocumentStateResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public document?: ParticipantDocument;

    public constructor(init?: Partial<CreateDocumentState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDocumentState'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDocumentStateResponse(); }
}

// @Route("/files/states")
// @DataContract
export class GetDocumentStatesByLabel implements IReturn<GetDocumentStatesByLabelResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public participantLabel?: string;

    public constructor(init?: Partial<GetDocumentStatesByLabel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDocumentStatesByLabel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDocumentStatesByLabelResponse(); }
}

// @Route("/files/state/update")
// @DataContract
export class UpdateDocumentState implements IReturn<UpdateDocumentStateResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public participantDocument?: ParticipantDocument;

    // @DataMember(Order=2)
    public redactedFields?: string[];

    // @DataMember(Order=3)
    public documentVerificationComments?: string;

    public constructor(init?: Partial<UpdateDocumentState>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateDocumentState'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateDocumentStateResponse(); }
}

// @DataContract
export class NotifySite implements IReturn<NotifySiteResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    // @DataMember(Order=2)
    public institutionCode?: string;

    // @DataMember(Order=3)
    public trialCoordinatorIds?: number[];

    public constructor(init?: Partial<NotifySite>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NotifySite'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new NotifySiteResponse(); }
}

// @DataContract
export class SendSiteEmail implements IReturnVoid, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    // @DataMember(Order=2)
    public institutionCode?: string;

    // @DataMember(Order=3)
    public trialCoordinatorEmails?: string[];

    public constructor(init?: Partial<SendSiteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSiteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @DataContract
export class SendMonthlySummaryEmail implements IReturnVoid, IPost
{
    [immerable]? = true;

    public reportMonthStart?: string;

    public constructor(init?: Partial<SendMonthlySummaryEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendMonthlySummaryEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @DataContract
export class SendWeeklyPendingDocumentsEmails implements IReturnVoid, IPost
{
    [immerable]? = true;


    public constructor(init?: Partial<SendWeeklyPendingDocumentsEmails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendWeeklyPendingDocumentsEmails'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

export class SendNotifySitesOfProcessedAndVerifiedDocumentsEmail implements IReturn<SendNotifySitesOfProcessedAndVerifiedDocumentsEmailResponse>, IPost
{
    [immerable]? = true;

    public patientId?: number;
    public trialId?: string;
    public institutionCode?: string;
    public formOids?: string[];

    public constructor(init?: Partial<SendNotifySitesOfProcessedAndVerifiedDocumentsEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendNotifySitesOfProcessedAndVerifiedDocumentsEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendNotifySitesOfProcessedAndVerifiedDocumentsEmailResponse(); }
}

// @Route("/user/permissions")
// @DataContract
export class PostHasUserPermissions implements IReturn<PostHasUserPermissionsResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public permissions?: Permission[];

    public constructor(init?: Partial<PostHasUserPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasUserPermissions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostHasUserPermissionsResponse(); }
}

// @Route("/trials")
// @DataContract
export class GetTrials implements IReturn<GetTrialsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetTrials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrials'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialsResponse(); }
}

// @Route("/trials/metadata")
// @DataContract
export class GetTrialsMetadata implements IReturn<GetTrialsMetadataResponse>
{
    [immerable]? = true;

    public asOf?: string;

    public constructor(init?: Partial<GetTrialsMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialsMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialsMetadataResponse(); }
}

// @Route("/trial")
// @DataContract
export class GetTrialById implements IReturn<GetTrialByIdResponse>, IGet
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<GetTrialById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialByIdResponse(); }
}

// @Route("/trial/label")
// @DataContract
export class GetTrialByOid implements IReturn<GetTrialByOidResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialOid?: string;

    public constructor(init?: Partial<GetTrialByOid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialByOid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialByOidResponse(); }
}

// @Route("/trial/cache/clear")
// @DataContract
export class DeleteTrialParticipantCacheData implements IReturnVoid
{
    [immerable]? = true;


    public constructor(init?: Partial<DeleteTrialParticipantCacheData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTrialParticipantCacheData'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/trials/master-groups")
// @DataContract
export class GetMasterGroupsByTrialId implements IReturn<GetMasterGroupsByTrialIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<GetMasterGroupsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMasterGroupsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMasterGroupsByTrialIdResponse(); }
}

// @Route("/trials/coordinating-groups")
// @DataContract
export class GetCoordinatingGroupsByTrialId implements IReturn<GetCoordinatingGroupsByTrialIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<GetCoordinatingGroupsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCoordinatingGroupsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCoordinatingGroupsByTrialIdResponse(); }
}

// @Route("/trials/{TrialId}/institutions")
// @DataContract
export class GetInstitutionsByTrialId implements IReturn<GetInstitutionsByTrialIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<GetInstitutionsByTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionsByTrialId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionsByTrialIdResponse(); }
}

// @DataContract
export class GetTrialCoordinatorsByTrialIdInstitutionCode implements IReturn<GetTrialCoordinatorsByTrialIdInstitutionCodeResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    // @DataMember(Order=2)
    public institutionCode?: string;

    public constructor(init?: Partial<GetTrialCoordinatorsByTrialIdInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialCoordinatorsByTrialIdInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialCoordinatorsByTrialIdInstitutionCodeResponse(); }
}

// @Route("/participants")
// @DataContract
export class GetParticipants implements IReturn<GetParticipantsResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    public constructor(init?: Partial<GetParticipants>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetParticipants'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetParticipantsResponse(); }
}

// @Route("/participant/{Label}")
// @DataContract
export class GetParticipantByLabel implements IReturn<GetParticipantByLabelResponse>, IGet
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public label?: string;

    public constructor(init?: Partial<GetParticipantByLabel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetParticipantByLabel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetParticipantByLabelResponse(); }
}

// @Route("/files/events")
// @DataContract
export class GetDocumentVerificationEvents implements IReturn<GetDocumentVerificationEventsResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public label?: string;

    public constructor(init?: Partial<GetDocumentVerificationEvents>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDocumentVerificationEvents'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDocumentVerificationEventsResponse(); }
}

// @DataContract
export class GetWeeklyProcessVerificationEventStats implements IReturn<GetWeeklyProcessVerificationEventStatsResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public trialId?: number;

    // @DataMember(Order=2)
    public institutionCode?: string;

    public constructor(init?: Partial<GetWeeklyProcessVerificationEventStats>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWeeklyProcessVerificationEventStats'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetWeeklyProcessVerificationEventStatsResponse(); }
}

// @DataContract
export class GetProcessVerificationDataByDocumentId implements IReturn<GetProcessVerificationDataByDocumentIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public documentId?: number;

    public constructor(init?: Partial<GetProcessVerificationDataByDocumentId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcessVerificationDataByDocumentId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProcessVerificationDataByDocumentIdResponse(); }
}

// @Route("/files")
export class GetOpenClinicaDocument implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public fileName?: string;

    public constructor(init?: Partial<GetOpenClinicaDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpenClinicaDocument'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/files/update")
// @DataContract
export class UpdateOpenClinicaDocument implements IReturn<UpdateOpenClinicaDocumentResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public documentId?: number;

    // @DataMember(Order=2)
    public studyOid?: string;

    // @DataMember(Order=3)
    public studySubjectLabel?: string;

    // @DataMember(Order=4)
    public eventOid?: string;

    // @DataMember(Order=5)
    public eventRepeat?: number;

    // @DataMember(Order=6)
    public formOid?: string;

    // @DataMember(Order=7)
    public itemName?: string;

    // @DataMember(Order=8)
    public itemRepeat?: number;

    public constructor(init?: Partial<UpdateOpenClinicaDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateOpenClinicaDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpdateOpenClinicaDocumentResponse(); }
}

// @DataContract
export class GetOverallTrialRedactionStatus implements IReturn<GetOverallTrialRedactionStatusResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public token?: string;

    public constructor(init?: Partial<GetOverallTrialRedactionStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOverallTrialRedactionStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetOverallTrialRedactionStatusResponse(); }
}

// @DataContract
export class GetTrialAndSiteRedactionStatus implements IReturn<GetTrialAndSiteRedactionStatusResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public token?: string;

    // @DataMember(Order=2)
    public trialId?: number;

    public constructor(init?: Partial<GetTrialAndSiteRedactionStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialAndSiteRedactionStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetTrialAndSiteRedactionStatusResponse(); }
}

// @DataContract
export class GetTrialSelectOptions implements IReturn<GetTrialsResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public token?: string;

    public constructor(init?: Partial<GetTrialSelectOptions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialSelectOptions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetTrialsResponse(); }
}

// @DataContract
export class GetLsgAndSiteStatus implements IReturn<GetLsgAndSiteStatusResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public token?: string;

    // @DataMember(Order=2)
    public coordinatingGroupId?: number;

    // @DataMember(Order=3)
    public trialId?: number;

    // @DataMember(Order=4)
    public institutionId?: number;

    public constructor(init?: Partial<GetLsgAndSiteStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLsgAndSiteStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetLsgAndSiteStatusResponse(); }
}

// @DataContract
export class GetLsgSelectOptions implements IReturn<GetLsgSelectOptionsResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public token?: string;

    public constructor(init?: Partial<GetLsgSelectOptions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLsgSelectOptions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetLsgSelectOptionsResponse(); }
}

// @DataContract
export class GetSiteSelectOptions implements IReturn<GetSiteSelectOptionsResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public token?: string;

    public constructor(init?: Partial<GetSiteSelectOptions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteSelectOptions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetSiteSelectOptionsResponse(); }
}

// @DataContract
export class GetOverallRedactionReasons implements IReturn<GetOverallRedactionReasonsResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public token?: string;

    public constructor(init?: Partial<GetOverallRedactionReasons>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOverallRedactionReasons'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetOverallRedactionReasonsResponse(); }
}

// @DataContract
export class GetLsgAndSiteRedactionReasons implements IReturn<GetLsgAndSiteRedactionReasonsResponse>, IReportRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public coordinatingGroupId?: number;

    // @DataMember(Order=2)
    public trialId?: number;

    // @DataMember(Order=3)
    public institutionId?: number;

    // @DataMember(Order=4)
    public token?: string;

    public constructor(init?: Partial<GetLsgAndSiteRedactionReasons>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLsgAndSiteRedactionReasons'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetLsgAndSiteRedactionReasonsResponse(); }
}

// @Route("/get/tp-pending-documents/{TrialId}/", "GET")
// @Route("/get/tp-pending-documents/{TrialId}/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpPendingDocuments implements IReturn<GetTpPendingDocumentsResponse>
{
    [immerable]? = true;

    public trialId?: number;
    public institutionId?: number;

    public constructor(init?: Partial<GetTpPendingDocuments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTpPendingDocuments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTpPendingDocumentsResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

/** @description Sign In */
// @Route("/auth", "OPTIONS,GET,POST,DELETE")
// @Route("/auth/{provider}", "OPTIONS,GET,POST,DELETE")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable]? = true;

    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider?: string;

    // @DataMember(Order=2)
    public state?: string;

    // @DataMember(Order=3)
    public oauth_token?: string;

    // @DataMember(Order=4)
    public oauth_verifier?: string;

    // @DataMember(Order=5)
    public userName?: string;

    // @DataMember(Order=6)
    public password?: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView?: string;

    // @DataMember(Order=10)
    public nonce?: string;

    // @DataMember(Order=11)
    public uri?: string;

    // @DataMember(Order=12)
    public response?: string;

    // @DataMember(Order=13)
    public qop?: string;

    // @DataMember(Order=14)
    public nc?: string;

    // @DataMember(Order=15)
    public cnonce?: string;

    // @DataMember(Order=17)
    public accessToken?: string;

    // @DataMember(Order=18)
    public accessTokenSecret?: string;

    // @DataMember(Order=19)
    public scope?: string;

    // @DataMember(Order=20)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

